"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyBase_1 = require("./WrappedPropertyBase");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var functions_1 = require("./functions");
var fixDateFormat_1 = require("../JSchema/fixDateFormat");
var getRuleMessage_1 = require("../JSchema/getRuleMessage");
var capitalize_1 = require("../methods/capitalize");
/**
 * obiekt reprezentujący pole tkestowe
 *
 * @export
 * @class WrappedPropertyString
 * @extends {WrappedPropertyBase<IInternal>}
 * @implements {IWrappedProperty}
 */
var WrappedPropertyString = /** @class */ (function (_super) {
    __extends(WrappedPropertyString, _super);
    function WrappedPropertyString(dest, parent, propName, schema, options) {
        var _this = _super.call(this, dest, parent, propName, schema, options) || this;
        (0, functions_1.wrapSchemaProps)(_this.$schema, _this._internal, 'number', [
            'maxLength',
            'minLength',
            'minimum',
            'maximum',
            'exclusiveMaximum',
            'exclusiveMinimum'
        ]);
        if (_this.$schema.warnings) {
            (0, functions_1.wrapWarningProps)(_this.$schema, _this._internal, 'number', [
                'maxLength',
                'minLength',
                'minimum',
                'maximum',
                'exclusiveMaximum',
                'exclusiveMinimum'
            ]);
        }
        (0, functions_1.initVue)(_this, _this._internal);
        return _this;
        // console.log('string created', propName, this._internal.vmUserData);
    }
    Object.defineProperty(WrappedPropertyString.prototype, "$format", {
        /**
       * pobranie formatu pola, `format` w schema lub w 'warnings'
       *
       * @readonly
       * @type {string}
       * @memberof WrappedPropertyString
       */
        get: function () {
            return this.$schema.format || (this.$schema.warnings && this.$schema.warnings.format) || '';
        },
        enumerable: false,
        configurable: true
    });
    /**
     * sprawdza pole pod kątem błedó
     *
     * @param {*} [value] wartość
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)} wynik
     * @memberof WrappedPropertyString
     */
    WrappedPropertyString.prototype.$validate = function (value, skipDirty) {
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        if (value === '' || value === null) {
            if (this.$schema.fieldRequired) {
                var message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'required', value, this.$schema);
                this.$validateResult = {
                    validation: 'required',
                    message: message,
                    expected: true
                };
                return message;
            }
            if (this.$schema.enum && this.$schema.enum.indexOf(value) === -1) {
                var message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'enum', value, this.$schema);
                this.$validateResult = {
                    validation: 'enum',
                    message: message,
                    expected: this.$schema.enum
                };
                return message;
            }
            return null;
        }
        return _super.prototype.$validate.call(this, value);
    };
    /**
     * sprawdza pole pod kątem ostrzeżeń
     *
     * @param {*} [value] wartośc pola
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {string[]} [checkResult]
     * @returns {string[]} lista ostrzeżeń lub pusta tablica
     * @memberof WrappedPropertyString
     */
    WrappedPropertyString.prototype.$check = function (value, skipDirty, checkResult) {
        if (this._internal.schema.warnings && !this.$disabled) {
            if (value === undefined) {
                value = this.$model;
            }
            if (!skipDirty) {
                this.$dirty = true;
            }
            checkResult = checkResult || [];
            this.$checkResult = [];
            var req = this.$schema.warnings.fieldRequired;
            // console.log('propName.get()', req, svalue);
            if (value === '' || value === null) {
                if (req) {
                    // console.timeEnd('(string)$validate');
                    var message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'required', value, this.$schema);
                    this.$checkResult.push({
                        validation: 'required',
                        message: message,
                        expected: true
                    });
                    checkResult.push(message);
                }
                if (this.$schema.warnings.enum && this.$schema.warnings.enum.indexOf(value) === -1) {
                    var message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'enum', value, this.$schema);
                    this.$checkResult.push({
                        validation: 'enum',
                        message: message,
                        expected: this.$schema.warnings.enum
                    });
                    checkResult.push(message);
                }
                return checkResult;
            }
            // console.timeEnd('(string)$validate');
            return _super.prototype.$check.call(this, value, skipDirty, checkResult);
        }
        return (this.$checkResult = []);
    };
    /**
     * naprawia format daty
     *
     * @returns {number}
     * @memberof WrappedPropertyString
     */
    WrappedPropertyString.prototype.$fixDateFormat = function () {
        switch (this.$format) {
            case 'date':
                // this._internal.parent, this.$key, value
                return (0, fixDateFormat_1.fixDateField)(this._internal.parent, this.$key, this._options.Vue) ? 1 : 0;
            case 'date-time':
                return (0, fixDateFormat_1.fixDateTimeField)(this._internal.parent, this.$key, this._options.Vue) ? 1 : 0;
        }
        return 0;
    };
    /**
     * pobranie wartości z modelu
     *
     * @protected
     * @returns {*}
     * @memberof WrappedPropertyString
     */
    WrappedPropertyString.prototype.getValue = function () {
        var svalue = this.$model;
        if (svalue !== null) {
            switch (this.$format) {
                case 'date':
                    if (svalue && svalue.length >= 10) {
                        var nsvalue = svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        svalue = nsvalue;
                    }
                    break;
                case 'date-time':
                    if (svalue && svalue.length >= 10) {
                        var nsvalue = svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        if (svalue.length === 19) {
                            var ntvalue = svalue.substr(11, 8);
                            // if (ntvalue !== '00:00:00') {
                            nsvalue += ' ' + ntvalue;
                            // }
                        }
                        // console.log('get date-time', svalue, nsvalue, ntvalue);
                        svalue = nsvalue;
                    }
                    break;
            }
        }
        return svalue || '';
    };
    /**
     * ustawienie wartości na modelu
     *
     * @protected
     * @param {*} newValue
     * @returns
     * @memberof WrappedPropertyString
     */
    WrappedPropertyString.prototype.setValue = function (newValue) {
        if (this.$disabled) {
            return;
        }
        // check save type
        if (newValue !== null) {
            if (newValue) {
                switch (this.$format) {
                    case 'uppercase':
                        newValue = newValue.toLocaleUpperCase();
                        break;
                    case 'lowercase':
                        newValue = newValue.toLocaleLowerCase();
                        break;
                    case 'capitalize':
                        newValue = (0, capitalize_1.default)(newValue);
                        break;
                    case 'date':
                        if (newValue.length >= 10 && newValue[2] == '.' && newValue[5] == '.') {
                            newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2);
                        }
                        break;
                    case 'date-time':
                        if (newValue.length >= 10 && newValue[2] == '.' && newValue[5] == '.') {
                            if (newValue.length === 19) {
                                newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2) + " " + newValue.substr(11);
                            }
                            else {
                                newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2) + " 00:00:00";
                            }
                        }
                        break;
                }
            }
        }
        this.$model = newValue;
        if (!this.$dirty && this._options.dirtyOnInput) {
            this.$dirty = true;
        }
    };
    return WrappedPropertyString;
}(WrappedPropertyBase_1.default));
exports.default = WrappedPropertyString;
WrappedPropertyCtor_1.default.string = WrappedPropertyString;
//# sourceMappingURL=WrappedPropertyString.js.map